module.exports = __webpack_public_path__ + "static/instagram-b473fcad595f09b0afe1270d9016ac8c.png";